/**
 * cardButton.tsx
 */
import Container from '../../../atoms/container/cardButtonContainer';
import InfoIcon from '../../../atoms/icons/cardInfoIcon';
import PlanIcon from '../../../atoms/icons/cardPlanIcon';
import PlayIcon from '../../../atoms/icons/cardPlayIcon';
import Text from '../../../atoms/text/cardButtonText';
import { CardButtonIcon } from '@shared/types/enums/card';

/**
 * Props for the CardButton component.
 */
interface Props {
  color?: string;
  focused?: boolean;
  iconType?: CardButtonIcon;
  text?: string;
}

/**
 * CardButton component.
 */
export default function CardButton({
  color,
  focused = false,
  iconType,
  text,
}: Props) {
  let Icon = null;

  switch (iconType) {
    case CardButtonIcon.INFO:
      Icon = InfoIcon;
      break;
    case CardButtonIcon.PLAN:
      Icon = PlanIcon;
      break;
    case CardButtonIcon.PLAY:
      Icon = PlayIcon;
      break;
  }

  const isPill = focused && iconType === CardButtonIcon.PLAN && !!text;

  return (
    <Container active={focused} color={color} pill={isPill}>
      {isPill ? <Text>{text}</Text> : null}
      {Icon ? <Icon focused={focused} isPill={isPill && focused} /> : null}
    </Container>
  );
}
